import { createAction, props } from '@ngrx/store';
import { IContent } from '../../core/services/locations.service';

// Load Provinces
export const loadProvinces = createAction('[Locations] Load Provinces');

export const loadProvincesSuccess = createAction(
  '[Locations] Load Provinces Success',
  props<{ provinces: IContent[] }>()
);

export const loadProvincesFailure = createAction(
  '[Locations] Load Provinces Failure',
  props<{ error: string }>()
);

// Load Districts (all)
export const loadDistricts = createAction('[Locations] Load Districts');

export const loadDistrictsSuccess = createAction(
  '[Locations] Load Districts Success',
  props<{ districts: IContent[] }>()
);

export const loadDistrictsFailure = createAction(
  '[Locations] Load Districts Failure',
  props<{ error: string }>()
);

// Load Districts by Province
export const loadDistrictsByProvince = createAction(
  '[Locations] Load Districts By Province',
  props<{ provinceId: string }>()
);

export const loadDistrictsByProvinceSuccess = createAction(
  '[Locations] Load Districts By Province Success',
  props<{ districts: IContent[] }>()
);

export const loadDistrictsByProvinceFailure = createAction(
  '[Locations] Load Districts By Province Failure',
  props<{ error: string }>()
);

// Load Sectors
export const loadSectors = createAction(
  '[Locations] Load Sectors',
  props<{ districtId: string }>()
);

export const loadSectorsSuccess = createAction(
  '[Locations] Load Sectors Success',
  props<{ sectors: IContent[] }>()
);

export const loadSectorsFailure = createAction(
  '[Locations] Load Sectors Failure',
  props<{ error: string }>()
);

export const loadCells = createAction(
  '[Locations] Load Cells',
  props<{ sectorId: string }>()
);

export const loadCellsSuccess = createAction(
  '[Locations] Load Cells Success',
  props<{ cells: IContent[] }>()
);

export const loadCellsFailure = createAction(
  '[Locations] Load Cells Failure',
  props<{ error: string }>()
);

export const loadVillages = createAction(
  '[Locations] Load Villages',
  props<{ cellId: string }>()
);

export const loadVillagesSuccess = createAction(
  '[Locations] Load Villages Success',
  props<{ villages: IContent[] }>()
);

export const loadVillagesFailure = createAction(
  '[Locations] Load Villages Failure',
  props<{ error: string }>()
);
